import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldGroupAttribute = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.attribute_group_id,
    name: item?.attribute_group_name,
    description: item?.attribute_group_description,
    order: item?.attribute_group_order,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getGroupAttributeListApi = ({ param, is_active }) => {
  const params = removeEmpty({
    param,
    is_active,
  })

  const config = {
    method: 'get',
    url: '/api/v1/group_attribute/',
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({
          data: _.map(res.data, mapFieldGroupAttribute),
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createGroupAttributeApi = ({
  attribute_group_name,
  attribute_group_description,
  attribute_group_order,
  is_active,
}) => {
  const data = {
    attribute_group_name,
    attribute_group_description,
    attribute_group_order,
    is_active,
  }

  const config = {
    method: 'post',
    url: '/api/v1/group_attribute/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getGroupAttributeByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/group_attribute/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data?.[0] })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteGroupAttributeByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/group_attribute/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateGroupAttributeByIdApi = ({
  id,
  attribute_group_name,
  attribute_group_description,
  attribute_group_order,
  is_active,
}) => {
  const data = {
    attribute_group_name,
    attribute_group_description,
    attribute_group_order,
    is_active,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/group_attribute/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
